import {createContext} from "react";

/** Measurement can hide a mounted tag; telemetry must use the same visibility answer. */
export const RecipientGiftVisibility = createContext(false);
